import { useMemo } from "react";
import { Nullable } from "../../../../../shared/src/@types/util";
import { BaseService } from "../../../../../shared/src/services";
import { getDefaultAxiosInstance } from "../../../../../shared/src/services/BaseService/AxiosService";
import { EUFinanceCaseAttachment } from "../../models/sobjects/EUFinanceCaseAttachment";
import { EUFinanceCaseAttachmentsPermissions } from "./models/EUFinanceCaseAttachmentsPermissions";

class EUFinanceCaseAttachmentService extends BaseService {
  private static readonly CASE_ID_PATH_SEGMENT = "caseId";

  constructor() {
    super(
      getDefaultAxiosInstance(),
      `/api/myemory/v0/eufinance/cases/${EUFinanceCaseAttachmentService.CASE_ID_PATH_SEGMENT}/case-attachments`
    );
  }

  public async getAllCaseAttachmentsByCaseId(
    caseId: string
  ): Promise<EUFinanceCaseAttachment[]> {
    const response = await super.get<EUFinanceCaseAttachment[]>({
      url: this.getPath().replace(
        `/${EUFinanceCaseAttachmentService.CASE_ID_PATH_SEGMENT}/`,
        `/${caseId}/`
      ),
      config: {
        cache: false,
      },
    });
    return response?.data ?? [];
  }

  public async getCaseAttachmentById(
    caseAttachmentId: Nullable<string>
  ): Promise<EUFinanceCaseAttachment> {
    if (!caseAttachmentId) {
      return {} as EUFinanceCaseAttachment;
    }

    const response = await super.get<EUFinanceCaseAttachment>({
      url: this.getPath(caseAttachmentId),
      config: {
        cache: false,
      },
    });

    return response?.data ?? {};
  }

  public async getCaseAttachmentsPermissionsByCaseId(
    caseId: Nullable<string>
  ): Promise<EUFinanceCaseAttachmentsPermissions> {
    if (!caseId) {
      return {} as EUFinanceCaseAttachmentsPermissions;
    }

    const response = await super.get<EUFinanceCaseAttachmentsPermissions>({
      url: this.getPath("/permissions").replace(
        `/${EUFinanceCaseAttachmentService.CASE_ID_PATH_SEGMENT}/`,
        `/${caseId}/`
      ),
      config: {
        cache: false,
      },
    });
    return response?.data ?? {};
  }
}

export default EUFinanceCaseAttachmentService;

export const useEUFinanceCaseAttachmentService =
  (): EUFinanceCaseAttachmentService =>
    useMemo(() => new EUFinanceCaseAttachmentService(), []);
